"use client";

import { c as _c } from "react/compiler-runtime";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import DropMobileMenuHandler from "@/components/waves/drops/DropMobileMenuHandler";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { useCallback, useState } from "react";
import MemeDropActions from "./meme-participation-drop/MemeDropActions";
import MemeDropArtistInfo from "./meme-participation-drop/MemeDropArtistInfo";
import MemeDropDescription from "./meme-participation-drop/MemeDropDescription";
import MemeDropHeader from "./meme-participation-drop/MemeDropHeader";
import MemeDropVoteStats from "./meme-participation-drop/MemeDropVoteStats";
import MemeDropTraits from "./MemeDropTraits";
interface MemeParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
}

// Border styling based on rank
const getBorderClasses = (drop: ExtendedDrop, isActiveDrop: boolean) => {
  const rank = drop.rank && drop.rank <= 3 ? drop.rank : null;
  const baseClasses = "tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden";
  if (isActiveDrop) {
    return `${baseClasses} desktop-hover:hover:tw-border-[#3CCB7F]/40 tw-bg-[#3CCB7F]/5`;
  } else if (rank === 1) {
    return `${baseClasses} desktop-hover:hover:tw-border-[#fbbf24]/40`;
  } else if (rank === 2) {
    return `${baseClasses} desktop-hover:hover:tw-border-[#94a3b8]/40`;
  } else if (rank === 3) {
    return `${baseClasses} desktop-hover:hover:tw-border-[#CD7F32]/40`;
  } else {
    return `${baseClasses} tw-border-iron-800`;
  }
};
export default function MemeParticipationDrop(t0) {
  const $ = _c(79);
  const {
    drop,
    activeDrop,
    showReplyAndQuote,
    location,
    onReply,
    onQuote
  } = t0;
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const isActiveDrop = activeDrop?.drop.id === drop.id;
  const isMobile = useIsMobileDevice();
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== drop.metadata) {
    t1 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[0] = drop.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  let t2;
  if ($[2] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[2] = drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const description = t2;
  let t3;
  if ($[4] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[4] = drop.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop || $[7] !== isActiveDrop) {
    t4 = getBorderClasses(drop, isActiveDrop);
    $[6] = drop;
    $[7] = isActiveDrop;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const borderClasses = t4;
  let t5;
  if ($[9] !== drop || $[10] !== onReply) {
    t5 = () => {
      onReply({
        drop,
        partId: drop.parts[0].part_id
      });
    };
    $[9] = drop;
    $[10] = onReply;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleOnReply = t5;
  let t6;
  if ($[12] !== drop || $[13] !== onQuote) {
    t6 = () => {
      onQuote({
        drop,
        partId: drop.parts[0].part_id
      });
    };
    $[12] = drop;
    $[13] = onQuote;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleOnQuote = t6;
  const t7 = `tw-w-full tw-group tw-relative ${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""}`;
  const t8 = `${borderClasses} ${location === DropLocation.WAVE ? "tw-bg-iron-900/80" : "tw-bg-iron-950"}`;
  let t9;
  if ($[15] !== drop) {
    t9 = <MemeDropArtistInfo drop={drop} />;
    $[15] = drop;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== title) {
    t10 = <MemeDropHeader title={title} />;
    $[17] = title;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== description) {
    t11 = <MemeDropDescription description={description} />;
    $[19] = description;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className="tw-flex tw-flex-col tw-mt-2 sm:tw-mt-1.5 sm:tw-ml-[3.25rem]">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className="tw-p-4">{t9}{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== artworkMedia || $[28] !== location) {
    t14 = artworkMedia && <div className={`tw-flex tw-justify-center tw-h-96 ${location === DropLocation.WAVE ? "tw-bg-iron-800/30" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[27] = artworkMedia;
    $[28] = location;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== drop) {
    t15 = <div className="tw-px-4 tw-py-4"><MemeDropTraits drop={drop} /></div>;
    $[30] = drop;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t15) {
    t16 = <>{t13}{t14}{t15}</>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== drop || $[37] !== handleOnQuote || $[38] !== handleOnReply || $[39] !== showReplyAndQuote || $[40] !== t16) {
    t17 = <DropMobileMenuHandler drop={drop} showReplyAndQuote={showReplyAndQuote} onReply={handleOnReply} onQuote={handleOnQuote}>{t16}</DropMobileMenuHandler>;
    $[36] = drop;
    $[37] = handleOnQuote;
    $[38] = handleOnReply;
    $[39] = showReplyAndQuote;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== drop.top_raters) {
    t18 = drop.top_raters ?? [];
    $[42] = drop.top_raters;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== drop.context_profile_context || $[45] !== drop.raters_count || $[46] !== drop.rating || $[47] !== drop.rating_prediction || $[48] !== drop.wave.voting_credit_type || $[49] !== t18) {
    t19 = <div className="tw-px-4 @[700px]:tw-px-0"><MemeDropVoteStats current={drop.rating} projected={drop.rating_prediction} votingCreditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={t18} userContext={drop.context_profile_context} /></div>;
    $[44] = drop.context_profile_context;
    $[45] = drop.raters_count;
    $[46] = drop.rating;
    $[47] = drop.rating_prediction;
    $[48] = drop.wave.voting_credit_type;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== canShowVote || $[52] !== drop) {
    t20 = canShowVote && <div className="tw-pt-4 tw-px-6 tw-flex tw-justify-center @[700px]:tw-pt-0 @[700px]:tw-px-0 tw-w-full @[700px]:tw-w-auto tw-border-t tw-border-solid tw-border-iron-800 @[700px]:tw-border-none tw-border-x-0 tw-border-b-0"><div onClick={_temp3}><VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} /></div></div>;
    $[51] = canShowVote;
    $[52] = drop;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== t19 || $[55] !== t20) {
    t21 = <div className="tw-flex tw-flex-col @[700px]:tw-flex-row tw-gap-3 @[700px]:tw-gap-y-0 tw-justify-between @[700px]:tw-items-center @[700px]:tw-px-4 tw-pb-4">{t19}{t20}</div>;
    $[54] = t19;
    $[55] = t20;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== drop) {
    t22 = <div className="tw-px-4 tw-pb-4 tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropReactions drop={drop} /></div>;
    $[57] = drop;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== drop || $[60] !== handleOnQuote || $[61] !== handleOnReply || $[62] !== isMobile || $[63] !== showReplyAndQuote) {
    t23 = <div className="tw-absolute tw-right-4 tw-top-2"><MemeDropActions drop={drop} isMobile={isMobile} showReplyAndQuote={showReplyAndQuote} onReply={handleOnReply} onQuote={handleOnQuote} /></div>;
    $[59] = drop;
    $[60] = handleOnQuote;
    $[61] = handleOnReply;
    $[62] = isMobile;
    $[63] = showReplyAndQuote;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== t17 || $[66] !== t21 || $[67] !== t22 || $[68] !== t23 || $[69] !== t8) {
    t24 = <div className={t8}>{t17}{t21}{t22}{t23}</div>;
    $[65] = t17;
    $[66] = t21;
    $[67] = t22;
    $[68] = t23;
    $[69] = t8;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== drop || $[72] !== isMobileScreen || $[73] !== isVotingModalOpen) {
    t25 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[71] = drop;
    $[72] = isMobileScreen;
    $[73] = isVotingModalOpen;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] !== t24 || $[76] !== t25 || $[77] !== t7) {
    t26 = <div className="tw-w-full tw-@container"><div className={t7}>{t24}{t25}</div></div>;
    $[75] = t24;
    $[76] = t25;
    $[77] = t7;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  return t26;
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp(m) {
  return m.data_key === "title";
}